export default __webpack_public_path__ + "static/media/hidePolygons.cf2131c7.svg";